"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDataMockSuites = void 0;
const apartment_webp_1 = __importDefault(require("../../../assets/images/apartment.webp"));
const bed_white_svg_1 = __importDefault(require("../../../assets/images/bed-white.svg"));
const calendar_svg_1 = __importDefault(require("../../../assets/images/calendar.svg"));
const close_svg_1 = __importDefault(require("../../../assets/images/close.svg"));
const digital_lock_webp_1 = __importDefault(require("../../../assets/images/digital-lock.webp"));
const mobile_service_svg_1 = __importDefault(require("../../../assets/images/mobile-service.svg"));
const reception_webp_1 = __importDefault(require("../../../assets/images/reception.webp"));
const room_webp_1 = __importDefault(require("../../../assets/images/room.webp"));
const diffs = [
    {
        imgUrl: room_webp_1.default,
        text: 'Estadias Customizadas',
        icon: calendar_svg_1.default,
        description: '1 Dia | 1 Mês | 1 Ano  Com a 360 Suítes, você que decide.',
    },
    {
        imgUrl: apartment_webp_1.default,
        text: 'Apartamentos Mobiliados',
        icon: bed_white_svg_1.default,
        description: 'Conforto, decoração e limpeza em qualquer apartamento.',
    },
    {
        imgUrl: reception_webp_1.default,
        text: 'Zero Burocracia',
        icon: close_svg_1.default,
        description: 'Sem fiador | Sem cheque caução | Sem dor de cabeça.',
    },
    {
        imgUrl: digital_lock_webp_1.default,
        text: 'Tecnologia Integrada',
        icon: mobile_service_svg_1.default,
        description: 'Atendimento 24H | Check-in Digital | Experiência Única.',
    },
];
const getDataMockSuites = () => new Promise(resolve => resolve(diffs));
exports.getDataMockSuites = getDataMockSuites;
